import type { FunctionComponent } from "react";
import { graphql, useFragment } from "react-relay";

import type { headerSectionTopHomeV2QueueItemsEdge$key } from "scmp-app/queries/__generated__/headerSectionTopHomeV2QueueItemsEdge.graphql";
import type { headerSectionTopHomeV2Section$key } from "scmp-app/queries/__generated__/headerSectionTopHomeV2Section.graphql";

import { Container, Dash, SectionTitleLink, SubsectionLink, SubsectionLinks } from "./styles";

type Props = {
  className?: string;
  reference: headerSectionTopHomeV2Section$key;
  subSectionReference?: headerSectionTopHomeV2QueueItemsEdge$key;
};

export const HomeV2SectionTopHeader: FunctionComponent<Props> = ({
  className,
  reference,
  subSectionReference,
}) => {
  const section = useFragment(
    graphql`
      fragment headerSectionTopHomeV2Section on Section {
        name
        ...entityLink
      }
    `,
    reference,
  );

  const subsections = useFragment(
    graphql`
      fragment headerSectionTopHomeV2QueueItemsEdge on QueueItemsEdge @relay(plural: true) {
        node {
          ... on Section {
            entityId
            name
            ...entityLink
          }
        }
      }
    `,
    subSectionReference ?? null,
  );

  const subsectionNodes = (subsections ?? []).map(({ node }) => node).filter(node => node.entityId);

  return (
    <Container className={className}>
      <SectionTitleLink reference={section}>{section.name}</SectionTitleLink>
      {subsectionNodes.length > 0 && (
        <>
          <Dash>-</Dash>
          <SubsectionLinks>
            {subsectionNodes.map(node => (
              <SubsectionLink key={node.entityId} reference={node}>
                {node.name}
              </SubsectionLink>
            ))}
          </SubsectionLinks>
        </>
      )}
    </Container>
  );
};

HomeV2SectionTopHeader.displayName = "HomeV2SectionTopHeader";
